/**
 * The number of dates to render.
 * @type {number}
 */
export const MONTH_DAYS_COUNT = 42
